export default __webpack_public_path__ + "static/media/Anud-Khan.f000acb4.jpg";